// src/pages/VideoDetail/VideoDetail.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProfile } from '../../hooks/useProfile';
import './VideoDetail.css';

const VideoDetail = () => {
  const { videoId } = useParams();
  const navigate = useNavigate();
  const { fetchVideoDetail, loading, error } = useProfile();
  const [video, setVideo] = useState(null);

  useEffect(() => {
    const loadVideo = async () => {
      try {
        const data = await fetchVideoDetail(videoId);
        setVideo(data);
      } catch (err) {
        console.error('Error loading video:', err);
      }
    };

    if (videoId) {
      loadVideo();
    }
  }, [videoId]);

  if (loading) {
    return (
      <div className="video-detail-page">
        <div className="loading-state">Loading video...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="video-detail-page">
        <div className="error-state">
          <p>{error}</p>
          <button onClick={() => navigate('/profile')} className="back-button">
            Back to Videos
          </button>
        </div>
      </div>
    );
  }

  if (!video) {
    return (
      <div className="video-detail-page">
        <div className="error-state">Video not found</div>
      </div>
    );
  }

  return (
    <div className="video-detail-page">
      <div className="video-detail-container">
        <button onClick={() => navigate('/profile')} className="back-button">
          ← Back to Videos
        </button>

        <div className="video-player-section">
          {video.video_url ? (
            <video 
              controls 
              autoPlay
              className="main-video-player"
              src={video.video_url}
            >
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="video-error">Video file not available</div>
          )}
        </div>

        <div className="video-info-section">
          <h1 className="video-title">{video.title}</h1>
          
          <div className="video-stats">
            <span className="stat-item">
              <span className="stat-icon">👁</span>
              {video.views} views
            </span>
            <span className="stat-item">
              <span className="stat-icon">⏱</span>
              {video.duration_formatted}
            </span>
            <span className="stat-item">
              <span className="stat-icon">📁</span>
              {video.file_size_mb} MB
            </span>
            <span className="stat-item category-badge">
              {video.category}
            </span>
          </div>

          {video.description && (
            <div className="video-description">
              <h3>Description</h3>
              <p>{video.description}</p>
            </div>
          )}

          <div className="video-meta">
            <p className="uploaded-by">
              Uploaded by <strong>{video.uploaded_by_name}</strong>
            </p>
            <p className="upload-date">
              {new Date(video.created_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoDetail;